import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { ConsultantService } from './consultant.service';
import { ConsultantComponent } from './consultant.component';

@Component({
    selector: 'convfact-consultantdelete',
    templateUrl: './consultant-dialog-delete.component.html',
    styleUrls: ['./consultant.component.css'],
    standalone: false
})

export class ConsultantDialogDeleteComponent {
  uid: string = this.data.uid;
  error_msg: string;
  error: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ConsultantComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    public consultantService: ConsultantService
  ) { }


  delete() {
    this.consultantService.deleteRelation(this.uid);
    this.error = true;
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
